
import { Corner, WindowState } from '$root/utils/enums';
const darkThemeMq = window.matchMedia("(prefers-color-scheme: dark)");
let darkMode = !!(darkThemeMq.matches)

export const initialState = {
    project : {
        availableProjects : null,
        selectedProjectId : -1,
        selectedProject : null,

        availablePlans: null,
        selectedPlan: null,

        selectedViewpointId: -1,
        leftYaw:0,
        leftPitch:0,
        leftHfov:90,

        splitView:false,

        planVisibleLayers:[],
    },
    ui: {
        darkMode: darkMode,
        projectSelectVisible: false,
        tagsLegendVisible:false,
        planView : {
            state: WindowState.NORMAL,
            position: Corner.SW,
            width: 480,
            height: 360,
        }
    }
}